import { Expose, Transform, Type } from "class-transformer";
import { DayjsUtils } from "src/libs/dayjs-utils";
import { BaseModel } from "src/shared/models/base.model";

export enum GameType {
    SCRATCH = "SCRATCH",
}

export const GameTitles = new Map<GameType, String>([
    [GameType.SCRATCH, "Raspa y gana"],
]);

export enum CantPlayReason {
    PreviouslyWon = "WASWINNER",
    NoStock = "ACHIEVEDSTOCK",
    UnfinishScratch = "FULFILL",
    ExceededTries = "EXCEEDEDTRIES",
    Nothing = "NOTHING",
}

export enum GameFrequency {
    DAILY = "DAILY",
}

export type DescriptionPart = {
    text: string;
    bold?: boolean;
};

export class ScratchGame extends BaseModel {
    @Expose()
    id = 0;

    @Expose()
    description = "";

    @Expose()
    image = "";

    @Expose()
    frecuency = GameFrequency.DAILY;

    @Expose()
    @Type(() => Date)
    @Transform(({ value }: { value: Date }) => DayjsUtils.getDate(value))
    next = "";

    @Expose()
    allowed = false;

    @Expose()
    type = GameType.SCRATCH;

    @Expose()
    reason: Nullable<CantPlayReason> = null;
}
